import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/system/agents/car-data-service/:id");
export const getIndexPath = returnPath("/system/agents/car-data-service");
